// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 여권테스트 (tools) — 발급/부여/취소안내 3탭
   색은 밴드QR 출력 화면(BandQrPrintPage.css)과 같은 slate 계열 다크 테마를 따른다.
   두 화면 모두 TEST 전용 도구라 운영 화면과 한눈에 구분되는 편이 낫다. */

.ptp-page {
  min-height: 100vh;
  background: #0f172a;
  color: #e2e8f0;
  display: flex;
  flex-direction: column;
}

/* ── 헤더 ───────────────────────────────────────── */

.ptp-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #1e293b;
}

.ptp-title {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ptp-title h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.ptp-btn-back {
  background: #1e293b;
  color: #e2e8f0;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 15px;
  cursor: pointer;
}

.ptp-badge-test {
  background: #7c2d12;
  color: #fed7aa;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
}

/* ── 탭 ─────────────────────────────────────────── */

.ptp-tabs {
  display: flex;
  gap: 8px;
  padding: 12px 20px 0;
  border-bottom: 1px solid #1e293b;
}

.ptp-tab {
  background: transparent;
  color: #94a3b8;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 10px 18px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.ptp-tab-active {
  color: #f8fafc;
  border-bottom-color: #f97316;
}

/* ── 본문 ───────────────────────────────────────── */

.ptp-body {
  flex: 1 1;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}

.ptp-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ptp-card {
  background: #111c31;
  border: 1px solid #1e293b;
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ptp-card h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.ptp-label {
  font-size: 15px;
  color: #94a3b8;
}

.ptp-select {
  font-size: 17px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid #334155;
  background: #1e293b;
  color: #f8fafc;
}

.ptp-select:focus {
  outline: none;
  border-color: #f97316;
}

.ptp-select:disabled {
  color: #64748b;
  cursor: not-allowed;
}

.ptp-input {
  font-size: 17px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid #334155;
  background: #1e293b;
  color: #f8fafc;
  font-family: monospace;
}

.ptp-input:focus {
  outline: none;
  border-color: #f97316;
}

.ptp-input:disabled {
  color: #64748b;
  cursor: not-allowed;
}

.ptp-hint {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #94a3b8;
}

.ptp-muted {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #94a3b8;
}

.ptp-btn-primary {
  font-size: 18px;
  font-weight: 700;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background: #f97316;
  color: #fff;
  cursor: pointer;
}

.ptp-btn-primary:disabled {
  background: #475569;
  cursor: not-allowed;
}

/* ── 키·값 한 줄 (여권 주소 표시) ───────────────── */

.ptp-kv {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ptp-kv-key {
  font-size: 13px;
  color: #94a3b8;
}

/* 주소는 길어서 좁은 화면에서 잘리면 안 된다 — 눈으로 호스트를 확인하는 값이다. */
.ptp-kv-val {
  font-family: monospace;
  font-size: 15px;
  color: #f8fafc;
  overflow-wrap: anywhere;
}

.ptp-kv-val-bad {
  color: #fca5a5;
  font-weight: 700;
}

/* ── 알림 블록 ──────────────────────────────────── */

.ptp-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 15px;
  line-height: 1.6;
}

.ptp-alert-icon {
  flex-shrink: 0;
}

.ptp-alert-msg {
  margin: 0;
  font-weight: 600;
}

.ptp-alert-sub {
  margin: 4px 0 0;
  font-size: 13px;
  opacity: 0.85;
}

.ptp-alert-ok {
  background: #052e16;
  border: 1px solid #16a34a;
  color: #bbf7d0;
}

.ptp-alert-err {
  background: #450a0a;
  border: 1px solid #dc2626;
  color: #fecaca;
}

.ptp-alert-warn {
  background: #422006;
  border: 1px solid #d97706;
  color: #fde68a;
}

.ptp-inline-err {
  margin: 0;
  font-size: 14px;
  color: #fca5a5;
}

/* ── 코드 목록 ──────────────────────────────────── */

.ptp-codes-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.ptp-codes-meta {
  font-size: 13px;
  color: #94a3b8;
}

/* 코드·주소가 길어 좁은 화면에서는 표만 가로 스크롤시킨다(페이지 전체가 흔들리지 않게). */
.ptp-table-wrap {
  overflow-x: auto;
}

.ptp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.ptp-table th,
.ptp-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #1e293b;
  white-space: nowrap;
}

.ptp-table th {
  color: #94a3b8;
  font-weight: 600;
}

.ptp-td-num {
  color: #64748b;
}

.ptp-td-code {
  font-family: monospace;
  color: #f8fafc;
}

.ptp-td-member {
  font-family: monospace;
  color: #cbd5e1;
}

.ptp-td-url {
  font-family: monospace;
  color: #94a3b8;
}

.ptp-status {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.ptp-status-available {
  background: #1e3a5f;
  color: #bfdbfe;
}

.ptp-status-registered {
  background: #052e16;
  color: #bbf7d0;
}

.ptp-status-void {
  background: #450a0a;
  color: #fecaca;
}

/* ── 부여 5콜 진행 단계 ─────────────────────────────
   5줄이 항상 **전부** 보인다(성공한 단계만 남기지 않는다). 아직 안 탄 단계가 흐리게라도
   보여야 "여기서 끊겼다" 가 한눈에 읽힌다. */

.ptp-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ptp-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #1e293b;
  background: #0f1a2e;
}

.ptp-step-icon {
  flex-shrink: 0;
  width: 20px;
  text-align: center;
  font-size: 15px;
}

.ptp-step-body {
  min-width: 0;
}

.ptp-step-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}

.ptp-step-auth {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  border: 1px solid #334155;
  border-radius: 999px;
  padding: 1px 8px;
}

.ptp-step-call {
  margin: 2px 0 0;
  font-family: monospace;
  font-size: 12px;
  color: #64748b;
  overflow-wrap: anywhere;
}

.ptp-step-detail {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #cbd5e1;
  overflow-wrap: anywhere;
}

/* 미실행 단계는 흐리게 — 실패 지점 바로 아래가 "안 탄 단계" 임이 보여야 한다. */
.ptp-step-idle {
  opacity: 0.5;
}

.ptp-step-running {
  border-color: #f97316;
}

.ptp-step-ok {
  border-color: #16a34a;
}

.ptp-step-fail {
  border-color: #dc2626;
  background: #2a0e0e;
}

.ptp-step-fail .ptp-step-detail {
  color: #fca5a5;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PassportTestPage.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oDAAoD;;AAEpD;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,4CAA4C;;AAE5C;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;6BAE6B;;AAE7B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* 여권테스트 (tools) — 발급/부여/취소안내 3탭\n   색은 밴드QR 출력 화면(BandQrPrintPage.css)과 같은 slate 계열 다크 테마를 따른다.\n   두 화면 모두 TEST 전용 도구라 운영 화면과 한눈에 구분되는 편이 낫다. */\n\n.ptp-page {\n  min-height: 100vh;\n  background: #0f172a;\n  color: #e2e8f0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── 헤더 ───────────────────────────────────────── */\n\n.ptp-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #1e293b;\n}\n\n.ptp-title {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ptp-title h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.ptp-btn-back {\n  background: #1e293b;\n  color: #e2e8f0;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.ptp-badge-test {\n  background: #7c2d12;\n  color: #fed7aa;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n/* ── 탭 ─────────────────────────────────────────── */\n\n.ptp-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 12px 20px 0;\n  border-bottom: 1px solid #1e293b;\n}\n\n.ptp-tab {\n  background: transparent;\n  color: #94a3b8;\n  border: none;\n  border-bottom: 3px solid transparent;\n  padding: 10px 18px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ptp-tab-active {\n  color: #f8fafc;\n  border-bottom-color: #f97316;\n}\n\n/* ── 본문 ───────────────────────────────────────── */\n\n.ptp-body {\n  flex: 1;\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 24px 20px 48px;\n}\n\n.ptp-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ptp-card {\n  background: #111c31;\n  border: 1px solid #1e293b;\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ptp-card h2 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.ptp-label {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.ptp-select {\n  font-size: 17px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 2px solid #334155;\n  background: #1e293b;\n  color: #f8fafc;\n}\n\n.ptp-select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.ptp-select:disabled {\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.ptp-input {\n  font-size: 17px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 2px solid #334155;\n  background: #1e293b;\n  color: #f8fafc;\n  font-family: monospace;\n}\n\n.ptp-input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.ptp-input:disabled {\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.ptp-hint {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #94a3b8;\n}\n\n.ptp-muted {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #94a3b8;\n}\n\n.ptp-btn-primary {\n  font-size: 18px;\n  font-weight: 700;\n  padding: 16px;\n  border-radius: 12px;\n  border: none;\n  background: #f97316;\n  color: #fff;\n  cursor: pointer;\n}\n\n.ptp-btn-primary:disabled {\n  background: #475569;\n  cursor: not-allowed;\n}\n\n/* ── 키·값 한 줄 (여권 주소 표시) ───────────────── */\n\n.ptp-kv {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ptp-kv-key {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n/* 주소는 길어서 좁은 화면에서 잘리면 안 된다 — 눈으로 호스트를 확인하는 값이다. */\n.ptp-kv-val {\n  font-family: monospace;\n  font-size: 15px;\n  color: #f8fafc;\n  overflow-wrap: anywhere;\n}\n\n.ptp-kv-val-bad {\n  color: #fca5a5;\n  font-weight: 700;\n}\n\n/* ── 알림 블록 ──────────────────────────────────── */\n\n.ptp-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: 12px;\n  padding: 14px 16px;\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.ptp-alert-icon {\n  flex-shrink: 0;\n}\n\n.ptp-alert-msg {\n  margin: 0;\n  font-weight: 600;\n}\n\n.ptp-alert-sub {\n  margin: 4px 0 0;\n  font-size: 13px;\n  opacity: 0.85;\n}\n\n.ptp-alert-ok {\n  background: #052e16;\n  border: 1px solid #16a34a;\n  color: #bbf7d0;\n}\n\n.ptp-alert-err {\n  background: #450a0a;\n  border: 1px solid #dc2626;\n  color: #fecaca;\n}\n\n.ptp-alert-warn {\n  background: #422006;\n  border: 1px solid #d97706;\n  color: #fde68a;\n}\n\n.ptp-inline-err {\n  margin: 0;\n  font-size: 14px;\n  color: #fca5a5;\n}\n\n/* ── 코드 목록 ──────────────────────────────────── */\n\n.ptp-codes-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.ptp-codes-meta {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n/* 코드·주소가 길어 좁은 화면에서는 표만 가로 스크롤시킨다(페이지 전체가 흔들리지 않게). */\n.ptp-table-wrap {\n  overflow-x: auto;\n}\n\n.ptp-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.ptp-table th,\n.ptp-table td {\n  padding: 8px 10px;\n  text-align: left;\n  border-bottom: 1px solid #1e293b;\n  white-space: nowrap;\n}\n\n.ptp-table th {\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.ptp-td-num {\n  color: #64748b;\n}\n\n.ptp-td-code {\n  font-family: monospace;\n  color: #f8fafc;\n}\n\n.ptp-td-member {\n  font-family: monospace;\n  color: #cbd5e1;\n}\n\n.ptp-td-url {\n  font-family: monospace;\n  color: #94a3b8;\n}\n\n.ptp-status {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ptp-status-available {\n  background: #1e3a5f;\n  color: #bfdbfe;\n}\n\n.ptp-status-registered {\n  background: #052e16;\n  color: #bbf7d0;\n}\n\n.ptp-status-void {\n  background: #450a0a;\n  color: #fecaca;\n}\n\n/* ── 부여 5콜 진행 단계 ─────────────────────────────\n   5줄이 항상 **전부** 보인다(성공한 단계만 남기지 않는다). 아직 안 탄 단계가 흐리게라도\n   보여야 \"여기서 끊겼다\" 가 한눈에 읽힌다. */\n\n.ptp-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ptp-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #1e293b;\n  background: #0f1a2e;\n}\n\n.ptp-step-icon {\n  flex-shrink: 0;\n  width: 20px;\n  text-align: center;\n  font-size: 15px;\n}\n\n.ptp-step-body {\n  min-width: 0;\n}\n\n.ptp-step-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.ptp-step-auth {\n  margin-left: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  border: 1px solid #334155;\n  border-radius: 999px;\n  padding: 1px 8px;\n}\n\n.ptp-step-call {\n  margin: 2px 0 0;\n  font-family: monospace;\n  font-size: 12px;\n  color: #64748b;\n  overflow-wrap: anywhere;\n}\n\n.ptp-step-detail {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #cbd5e1;\n  overflow-wrap: anywhere;\n}\n\n/* 미실행 단계는 흐리게 — 실패 지점 바로 아래가 \"안 탄 단계\" 임이 보여야 한다. */\n.ptp-step-idle {\n  opacity: 0.5;\n}\n\n.ptp-step-running {\n  border-color: #f97316;\n}\n\n.ptp-step-ok {\n  border-color: #16a34a;\n}\n\n.ptp-step-fail {\n  border-color: #dc2626;\n  background: #2a0e0e;\n}\n\n.ptp-step-fail .ptp-step-detail {\n  color: #fca5a5;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
